export default __webpack_public_path__ + "asset/img/avatar~03898785.jpg";